export const AV_ADDRESS = 'AV Address';
export const AV_ADDRESS_RETRY = 'AV Retry Address';
export const AV_ID_UPLOAD = 'AV ID Upload';
export const AV_REVIEW = 'AV Review';
export const AV_FAIL = 'AV Fail';

const getStepName = step => {
  return step === 'address_retry' ? AV_ADDRESS_RETRY : AV_ADDRESS;
};

export function trackAddressUpdateFailure(step, data) {
  const eventName = `${getStepName(step)} Form Submission Failed`;
  analytics.track(eventName, data);
}

export function trackAddressUpdateSuccess(step) {
  const eventName = `${getStepName(step)} Form Submission Successful`;
  analytics.track(eventName);
}

export function trackIdSubmitSuccess() {
  const eventName = 'AV ID Submitted Successfully';
  analytics.track(eventName);
}

export function trackLogOutButton(page) {
  analytics.track(`${page} Page Sign Out Button Clicked`);
}

export function trackLogOutLink() {
  analytics.track('AV Form Logout Link Clicked');
}

export function trackIdUploadModalAbandoned() {
  analytics.track(`${AV_ID_UPLOAD} Modal Abandonded`);
}

export function trackIdUploadModalOpened() {
  analytics.track(`${AV_ID_UPLOAD} Modal Opened`);
}

export function trackStepEntered(step) {
  analytics.track('Entered AV Step', {
    step: step,
  });
}



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/tracking.js